(function () {
  const PURITY_API = 'https://purityreport.rowecasaorganics.com/Downlod_Report';

  document.querySelectorAll('.search-form__form').forEach(function (form) {
    const formId   = form.id;
    const input    = form.querySelector('.search-form__input');
    const feedback = document.getElementById(formId + '-feedback');
    const results  = document.getElementById(formId + '-results');

    if (!input || !feedback || !results) return;

    function setFeedback(msg, type) {
      feedback.textContent = msg;
      feedback.className = 'search-form__feedback' + (type ? ' search-form__feedback--' + type : '');
    }

    function renderResults(items) {
      results.innerHTML = '';
      items.forEach(function (item) {
        const card = document.createElement('div');
        card.className = 'search-form__result-item';

        const imgWrap = document.createElement('div');
        imgWrap.className = 'search-form__result-item-img';
        const img = document.createElement('img');
        img.src = item.sl_product_img;
        img.alt = item.sl_product_title;
        img.loading = 'lazy';
        imgWrap.appendChild(img);

        const info = document.createElement('div');
        info.className = 'search-form__result-item-info';

        const title = document.createElement('div');
        title.className = 'search-form__result-item-title';
        title.textContent = item.sl_product_title;

        const batch = document.createElement('div');
        batch.className = 'search-form__result-item-batch';
        batch.textContent = 'Batch Code: ' + item.sl_products_batch;

        const dl = document.createElement('a');
        dl.className = 'search-form__result-item-download';
        dl.href = item.sl_product_doc;
        dl.target = '_blank';
        dl.rel = 'noopener';
        dl.textContent = 'Download Report';

        info.appendChild(title);
        info.appendChild(batch);
        info.appendChild(dl);
        card.appendChild(imgWrap);
        card.appendChild(info);
        results.appendChild(card);
      });
    }

    function lookup() {
      const lot = input.value.trim();
      if (!lot) return;

      results.innerHTML = '';
      setFeedback('Searching...', 'loading');

      fetch(PURITY_API + '?batch_code=' + encodeURIComponent(lot))
        .then(function (res) { return res.text(); })
        .then(function (text) {
          let data;
          try { data = JSON.parse(text); } catch (e) { data = text; }

          if (typeof data === 'string' || data === 'sorry batchcode is not valid') {
            setFeedback('Invalid LOT number. Please check and try again.', 'error');
          } else if (data && data.sl_document && data.sl_document.length) {
            setFeedback('');
            renderResults(data.sl_document);
          } else {
            setFeedback('No results found for that LOT number.', 'error');
          }
        })
        .catch(function () {
          setFeedback('Something went wrong. Please try again.', 'error');
        });
    }

    const button = form.querySelector('.search-form__submit-button');
    if (button) button.addEventListener('click', lookup);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); lookup(); }
    });
  });
})();
